import { Helmet } from "react-helmet-async";
import { Link, routes } from "wasp/client/router";

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://optimistic-news.com/about" />
        <title>About - Optimistic News</title>
        <meta
          name="description"
          content="Learn about Optimistic News, our mission, and how we curate positive journalism with community discussion."
        />
        <meta property="og:title" content="About - Optimistic News" />
        <meta
          property="og:description"
          content="Learn about Optimistic News, our mission, and how we curate positive journalism with community discussion."
        />
        <meta property="og:url" content="https://optimistic-news.com/about" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="prose dark:prose-invert max-w-none">
          <h1>About Optimistic News</h1>
          <p>
            Optimistic News is a platform for people who want to stay informed
            without getting trapped in doom-scrolling. We focus on credible
            reporting about progress, solutions, and constructive change.
          </p>

          <h2>What We Do</h2>
          <ul>
            <li>Curate uplifting, high-signal stories from trusted outlets.</li>
            <li>
              Offer a discussion space for thoughtful, civil conversations.
            </li>
            <li>
              Publish a weekly digest with the most meaningful developments.
            </li>
          </ul>

          <h2>How to Get Started</h2>
          <p>
            Browse today&apos;s stories in{" "}
            <Link to={routes.ArticlesRoute.to}>Articles</Link>, join the
            conversation in{" "}
            <Link to={routes.DiscussionsRoute.to}>Discussions</Link>, or support
            the project on the{" "}
            <Link to={routes.PricingPageRoute.to}>Pricing</Link> page.
          </p>

          <h2>Legal & Contact</h2>
          <p>
            For legal details, see our{" "}
            <Link to={routes.PrivacyPolicyRoute.to}>Privacy Policy</Link> and{" "}
            <Link to={routes.TermsOfServiceRoute.to}>Terms of Service</Link>.
            For questions, reach us at{" "}
            <a href="mailto:hello@optimistic-news.com">
              hello@optimistic-news.com
            </a>
            .
          </p>
        </div>
      </div>
    </>
  );
}
